import React from 'react';
import {ScrollRestoration} from 'react-router-dom';
import PageContainer from '../../ui/PageContainer';
import {AuthContextProvider} from '../AuthContext';

const NoUserRoot = () => {
  return (
    <AuthContextProvider>
      <ScrollRestoration/>
      <PageContainer/>
    </AuthContextProvider>
  );
};

export default NoUserRoot;
